import { render, staticRenderFns } from "./communityPlugin.vue?vue&type=template&id=bb223018&"
import script from "./communityPlugin.vue?vue&type=script&lang=js&"
export * from "./communityPlugin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports